import { AuthorizationInfoCard, DiscrepancyTable } from './components';
import { NavigateLinks, LoaderBackdrop } from '@/components';
import { useViewAuthorization } from './hooks';

export const ViewAuthorization = () => {
  const {
    breadcrumbs,
    authorization,
    isAuthorizationLoading,
    missingTableData,
    surplusTableData,
    matchedTableData,
  } = useViewAuthorization();

  if (isAuthorizationLoading) {
    return <LoaderBackdrop />;
  }

  if (!authorization) {
    return (
      <section className='flex flex-col gap-6 w-full h-full'>
        <NavigateLinks actualPage='Autorización' breadcrumbs={breadcrumbs} />
        <div className='bg-white p-10 rounded-xl shadow-sm text-center text-gray-500 font-semibold'>
          No se encontró la solicitud de autorización.
        </div>
      </section>
    );
  }

  return (
    <section className='flex flex-col gap-6 w-full h-full pb-10'>
      <NavigateLinks
        actualPage='Detalle de Autorización'
        breadcrumbs={breadcrumbs}
      />
      <div className='w-full flex flex-col gap-6'>
        <AuthorizationInfoCard authorization={authorization} />
        <DiscrepancyTable
          data={missingTableData}
          title='Pedidos Faltantes'
          description='Pedidos retirados por el conductor que no se presentaron en el control de arribo.'
          titleColorClass='text-red-600'
          emptyMessage='Sin pedidos faltantes'
        />
        <DiscrepancyTable
          data={surplusTableData}
          title='Pedidos No Solicitados'
          description='Pedidos presentados en el control de arribo que no registran un retiro previo por el conductor.'
          titleColorClass='text-orange-600'
          emptyMessage='Sin pedidos no solicitados'
        />
        <DiscrepancyTable
          data={matchedTableData}
          title='Pedidos Arribados Correctamente'
          description='Pedidos retirados por el conductor que se presentaron correctamente en el control de arribo.'
          titleColorClass='text-emerald-600'
          emptyMessage='Sin pedidos arribados correctamente'
        />
      </div>
    </section>
  );
};

export default ViewAuthorization;
